/* global XDomainRequest */

window.o_global = window.o_global || {};

/**
 * Global asset loader to retrieve non-critical assets asynchronously
 * and save them to localStorage (if available).
 */
o_global.assetLoader = (function() {
    "use strict";

    /**
     * Parse the o_global.assets JSON object and try to retrieve key and path
     * for all non-critical assets defined in o_global.assets.
     */
    function kickIt() {
        var i,
            group,
            item;

        if (o_global.assets) {
            for (i in o_global.assets) {
                if (o_global.assets.hasOwnProperty(i)) {
                    group = o_global.assets[i];
                    for (item in group) {
                        if (group.hasOwnProperty(item)) {
                            _handleAssets(i, i + "_" + item, group[item]);
                        }
                    }
                }
            }
        }
    }

    /**
     * Either load asset content from localStorage or retrieve newer version
     * and use http cache.
     *
     * @param {String} type     Type of Assets (atm either "css" or "js").
     * @param {String} key      CacheKey for localStorage.
     * @param {String} path     Url where the asset file should be retrieved from.
     *
     * @private
     */

    function _handleAssets(type, key, path) {
        var storage = new o_global.Storage(function() {
                return window.localStorage;
            }),
            keySub = key,   // Substring of cacheKey without hash.
            deprecatedKey,  // LocalStorage key of the cache item that will be deleted later on.
            item,
            storedKey;

        if (storage.isAvailable) {
            item = storage.getItem(key);

            if (item) {
                // An localStorage item for the given key exists and will be added to the DOM directly.
                _addContentToDom(type, item);
            } else {
                // Actual asset is currently not cached in localStorage.
                // Remove hash from cachekey to check for older version of vertical assets.
                keySub = keySub.split("_");
                keySub.pop();
                keySub = keySub.join("_");

                // Get old key if it exists. For loop needed for legacy browser
                for (var i = 0; i < storage.storage.length; i++) {
                    storedKey = storage.storage.key(i);
                    if (storedKey.indexOf(keySub) > -1) {
                        deprecatedKey = storedKey;
                    }
                }

                // Retrieve actual file, add it to the DOM and localStorage.
                _load(path, function(content) {
                    _addContentToDom(type, content);
                    storage.setItem(key, content);
                });

                // Remove invalid cache item.
                if (deprecatedKey) {
                    storage.removeItem(deprecatedKey);
                }
            }
        } else {
            // No localStorage available, just add good ol' script-/style-tags.
            _addTag(type, path);
        }
    }

    /**
     * Load asset file and return it's content.
     * XDomainRequest necessary due to cross-origin issue in IE9
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/XDomainRequest
     *
     * @param {String} path         Url where the file should be loaded from.
     * @param {Function} callback   Callback Function that will handle the xhr responseText.
     *
     * @private
     */
    function _load(path, callback) {
        var xdr,
            xhr;

        try {
            if (window.XDomainRequest) {
                xdr = new XDomainRequest();
                xdr.open("GET", path);
                xdr.onload = function() {
                    callback(xdr.responseText);
                };

                setTimeout(function() {
                    xdr.send();
                }, 0);
            } else {
                xhr = new XMLHttpRequest();
                xhr.open("GET", path);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status >= 200 && xhr.status < 400) {
                            callback(xhr.responseText);
                        }
                    }
                };

                xhr.send(null);
            }
        } catch (e) {
        }
    }

    /**
     * Add retrieved content (either ajax or localStorage) and inject it to the DOM.
     *
     * @param {String} type The type of the content which should be added to the DOM ("js" or "css")
     * @param {String} content The content which should be added to the DOM
     *
     * @private
     */
    function _addContentToDom(type, content) {
        switch (type) {
            case "css":
                _addStyle(content);
                break;
            case "js":
                _addScript(content);
                break;
            default:
                break;
        }
    }

    /**
     * Append a script tag to the document and set it's content.
     *
     * @param {String} content The script content
     *
     * @private
     */
    function _addScript(content) {
        var script = document.createElement("script");

        script.text = content;
        document.body.appendChild(script);
    }

    /**
     * Append style block to head and inject styles.
     *
     * @param {String} content The css content
     *
     * @private
     */
    function _addStyle(content) {
        var style = document.createElement("style"),
            head = document.head || document.getElementsByTagName("head")[0];

        style.type = "text/css";
        head.appendChild(style);
        style.textContent = content;
    }

    /**
     * Fallback method! Add link or script tags for browser that don't support localStorage.
     *
     * @param {String} type The type of the tag which should be added ("js" or "css")
     * @param {String} path The source path of the tag
     *
     * @private
     */
    function _addTag(type, path) {
        switch (type) {
            case "css":
                var style = document.createElement("link"),
                    head = document.head || document.getElementsByTagName("head")[0];

                style.rel = "stylesheet";
                style.type = "text/css";
                style.href = path;
                head.appendChild(style);
                break;
            case "js":
                var script = document.createElement("script");

                script.src = path;
                document.body.appendChild(script);
                break;
            default:
                break;
        }
    }

    // Run AssetLoader!
    o_global.eventLoader.onLoad(0, kickIt);

    // Expose init method
    return {
        "kickIt": kickIt
    };
}());

